import OliverText from "@builder/components/general/OliverText";
import "./style.scss";
import { useRef, useState } from "react";
import { useOutsideClick } from "@builder/hooks/useOutsideClick";
import classNames from "classnames";

interface AltSelectInputProps<T> {
    options: T[];
    selected?: string;
    getLabel: (option: T) => string;
    callback: (option: T) => void;
    title?: string;
    className?: string;
    disabled?: boolean;
    direction?: "row" | "column";
}

const AltSelectInput = <T,>({ options, selected, getLabel, callback, title, className, disabled, direction }: AltSelectInputProps<T>) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const selectRef = useRef<HTMLDivElement>(null);

    useOutsideClick(selectRef, () => setIsOpen(false));

    const wrapperClass = classNames("alt-select-input-wrapper", {
        [`${className}`]: className,
        [`${direction}`]: direction
    });

    const handleSelect = (option: T) => {
        setIsOpen(false);
        callback(option);
    };

    const isDisabled = disabled || options.length === 0;

    const innerWrapperClass = classNames("select-wrapper", {
        ["select-active"]: isOpen,
        ["disabled"]: isDisabled
    });

    return (
        <div className={wrapperClass}>
            {title && <OliverText text={title} size="xs" />}
            <div className={innerWrapperClass} ref={selectRef}>
                {!isDisabled && <img src="/angled-arrow-down.svg" />}
                <input type="text" value={selected || ""} readOnly onClick={() => setIsOpen(!isOpen)} disabled={isDisabled} />
                {isOpen && (
                    <div className="select-input-options">
                        {options.map((option, index) => (
                            <div className="select-input-option" key={index} onClick={() => handleSelect(option)}>
                                {getLabel(option)}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AltSelectInput;
